<div class="flex flex-col md:gap-1.5 gap-2.5" *transloco="let t; currentLang as currentLang">
    <div class="flex gap-1.5 items-center">
        <span class="text-[#344054] text-lg md:text-base font-semibold">{{ currentLang ==='bn' ? (percentage() | toBanglaNumber) : percentage() }}%</span>
        @if(days()){
            <div class="px-2 py-0.5 rounded-full border border-[#E4E7EC] bg-[#F9FAFB]">
                <!-- @let day = currentLang === 'bn' ? (days() | toBanglaNumber) : days(); -->
                <!-- <p class="text-[11px] font-medium text-[#344054]">{{t('updated_days_ago', {days: day})}}</p> -->
                 @let updatedTime = days() | timeAgo : currentLang;
                <p class="text-[11px] font-medium text-[#344054]">{{currentLang === 'en' ? updatedTime : (updatedTime | toBanglaNumber)}}</p>
            </div>
        }
    </div>

    <app-progress-bar 
        [percentage]="percentage()" 
        [backgroundColor]="'#0E73A9'" 
        [width]="'md:w-[264px] w-full'"
        [height]="'md:h-[8px] h-[6px]'" 
        [trackColor]="'#E4E7EC'" 
        [borderRadius]="'4px'">
    </app-progress-bar>

    <div class="w-full flex items-center justify-between">
        <p class="text-[#344054] font-medium text-sm">{{ label() }}</p>
        <a [href]="`${redirectUrl()}?lang=${currentLang}`" target="_blank"
            class="text-[#0E73A9] hover:text-[#10557C] text-sm font-medium underline underline-offset-4">
            {{t('update')}}
        </a>
    </div>
</div>
